import { configureStore } from '@reduxjs/toolkit';
import authSlice from './reducers/authSlice';
import profileSetupSlice from './reducers/profileSetupSlice';
import profileSlice from './reducers/profileSlice';
import preferencesSlice from './reducers/preferences';
import visitorInfoSlice from './reducers/visitorInfoSlice';

export const store = configureStore({
  reducer: {
    authSlice: authSlice,
    profileSetupSlice: profileSetupSlice,
    profileSlice: profileSlice,
    visitorInfoSlice: visitorInfoSlice,
    preferencesSlice: preferencesSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
